const AdministracionConvocatorias = {
    
    Aspirantes:'/CONVOCATORIA/Administracion/Aspirantes',
    HabilitaAspirante:'/CONVOCATORIA/Administracion/Aspirantes',
    CambiarEstatusAspirante:'CONVOCATORIA/Administracion/Aspirantes/CambiarEstatus',
    ObtenerTitulosConvocatorias:'CONVOCATORIAS/TitulosDeConvocatorias',
    ObtenerEstadosConvocatorias:'CONVOCATORIAS/EstadosDeAsistentes',
    GenerarReporte:'/CONVOCATORIA/Administracion/Reporte?',
    EdicionInformacionDeAspirante:'/CONVOCATORIAS/AsistenteEdicion?FolioDeAspirante=',
    GenerarReporteExcel:'/CONVOCATORIA/Administracion/ReporteExcel?',
    ObtenerCategorias:'/CONVOCATORIAS/GetCategorysCalls'

}

export default AdministracionConvocatorias;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/Convocatorias/sistema/Administracion/convocatorias.js
// module id = null
// module chunks = 